module.exports = __webpack_public_path__ + "img/seja_aluno.53c86364.png";